import { v4 as uuidv4 } from 'uuid';

export const SCROLL_COMPONENT_ID = uuidv4();
export const POPUP_OVERLAY_ID = uuidv4();
export const NAVIGATION_ID = uuidv4();
export const MENU_DIALOG_CONTAINER_ID = uuidv4();

export default {
  //
  // Images
  //

  // S3 without CDN
  // STATIC_RESOURCES_BASE_URL: process.env.REACT_APP_CDN_URL || 'https://s3.eu-central-1.amazonaws.com/lootboy-static-files',

  // AWS CloudFront -> S3
  // STATIC_RESOURCES_BASE_URL: process.env.REACT_APP_CDN_URL || 'https://d37g512o45qnur.cloudfront.net',

  // CloudFlare -> AWS CloudFront -> S3
  // STATIC_RESOURCES_BASE_URL: process.env.REACT_APP_CDN_URL || 'https://images.lootboy.de',

  // StackPath -> AWS CloudFront -> S3
  STATIC_RESOURCES_BASE_URL:
    process.env.REACT_APP_CDN_URL || 'https://cdn.lootboy.app',

  //
  // Other
  //

  MAX_LOOTPACK_PURCHASES: 10,
  MAX_NUMBER_OF_SEARCH_HISTORY_ENTRIES: 3,

  IS_LOOTBOY_COM: window.location.hostname === 'www.lootboy.com',
  SOVENDUS_JS: '//api.sovendus.com/sovabo/common/js/flexibleIframe.js',
  SOVENDUS_SHOP_ID_DEFAULT: '3669',
  SOVENDUS_SHOP_ID: {
    DE: '3669',
    AT: '4114',
    CH: '4115',
  },
  SOVENDUS_MEDIUM: '2',

  TWITCH_CHANNEL: 'lootboyapp',

  INTERNAL_CURRENCIES: ['LOOTCOIN', 'LOOTGEM', 'FREE'],
};
